import { Option } from "seneca-common/utils/form-hook/inputs/common";

export const DAILY_EXAM_QUESTIONS_LIMIT = 3;

export const MAX_IMAGE_WIDTH = 512;
export const MAX_IMAGE_HEIGHT = Math.round(MAX_IMAGE_WIDTH * 1.5);

export const TeacherFeedbackTypes = [
  "Question not relevant to this course",
  "Error in the question or mark scheme",
  "Other"
];

export const FeedbackTypes = [
  "Misspelling incorrectly updated",
  ...TeacherFeedbackTypes
];

export const UNRELIABLE_MARKING = "Unreliable marking";

export const FeedbackTypesAutoMarkedEQ = [UNRELIABLE_MARKING, ...FeedbackTypes];

export const TeacherFeedbackTypesAutoMarkedEQ = [
  UNRELIABLE_MARKING,
  ...TeacherFeedbackTypes
];

export const EQSortOptions = {
  Topics: { label: "Topics", value: "Topics" },
  Accuracy: { label: "Accuracy", value: "Accuracy" },
  Difficulty: { label: "Difficulty", value: "Difficulty" },
  Marks: { label: "Marks", value: "Marks" }
};

export type EQSortOption = Option<string>;

export const MAX_EQ_ONLY_ASSIGNMENT_EQ_COUNT = 10;
export const MAX_STANDARD_ASSIGNMENT_EQ_COUNT = 3;

export const SELF_MARKING_DONT_KNOW_MARK = -1;
export const EQ_SESSION_BUTTON_WIDTH = "12rem";
